/**
 * Computes the new recents list after adding a domain.
 * Add-to-front with dedup, trimmed to maxRecents.
 */
export function addToRecentsList(current: number[], domainId: number, maxRecents: number): number[] {
    const filtered = current.filter((id) => id !== domainId)
    return [domainId, ...filtered].slice(0, maxRecents)
}

/**
 * Filters a raw recents array to only IDs present in domainMap.
 */
export function filterValidIds(ids: number[], domainMap: Map<number, unknown>): number[] {
    return ids.filter((id) => domainMap.has(id))
}
